import Row from "../../atoms/Row";
import styled from "styled-components";
import Chevron from "../../atoms/Chevron";

export const DownIconContainer = styled(Row)`
  position: absolute;
  bottom: 60px;
  justify-content: center;
  align-items: center;
  width: 100vw;
`;

export const FloatingChevron = styled(Chevron).attrs({
  height: 20,
  width: 20,
})`
  animation: float 3s ease-in-out infinite;

  @keyframes float {
    0% {
      transform: translatey(0px) rotate(90deg);
    }
    70% {
      transform: translatey(-15px) rotate(90deg);
    }
    100% {
      transform: translatey(0px) rotate(90deg);
    }
  }
`;
